
const buttons = document.querySelectorAll('.js-job-application')
const sendResume = document.getElementById('send-work-resume')

if(sendResume) {
    sendResume.addEventListener('click', event => clickHandler(event))
}


if(buttons.length !== 0) {
    buttons.forEach(button => {
       button.addEventListener('click', event => clickHandler(event))
})}

function clickHandler(event) {

    const modal = document.getElementById('modal-plug')
    const btnClose = document.getElementById('modal-plug-close')
    modal.classList.remove('modal__plug__hidden')
    btnClose.addEventListener('click', () => { modal.classList.add('modal__plug__hidden') })

}

// Слайдер смены фотографии на странице Работа у нас
const $activeBlock = document.querySelector('.big-image-active-js')
const $blocksList = document.querySelectorAll('.slick-image-js')


class EmployeeComment  {
    constructor($activeBlock, $blocksList) {
        this.$activeBlock = $activeBlock
        this.$blocksList = $blocksList
        this.$mainSlider = $('.js-slider-works');
        this.$navSlider = $('.js-slider-works-nav');
        this.changeSliderHandler = this.changeSliderHandler.bind(this);
    }

    init() {
        this.$img = this.$activeBlock.querySelector('.image__container img')
        this.$fio = this.$activeBlock.querySelector('.image__title').firstElementChild
        this.$position = this.$activeBlock.querySelector('.image__subtitle').firstElementChild

        if (this.$mainSlider && this.$navSlider) {
            this.$mainSlider.on('swipe', this.changeSliderHandler);
            this.$navSlider.on('swipe', this.changeSliderHandler);
        }

        this.$blocksList.forEach($block => $block.onclick = event => this.clickHandler(event))
    }

    changeSliderHandler() {
        const $activeItem = this.$navSlider.find('.slick-slide.slick-current.slick-active');
        const $activeItemImgWrapper = $activeItem.find('.slick-image-js');

        if (!$activeItemImgWrapper.length || !$activeItemImgWrapper.get(0)) {
            return;
        }

        this.setActiveText($activeItemImgWrapper.get(0));
    }

    setActiveText(item) {
        const data = item.attributes
        const urlImg = data['data-img'].value
        const position= data['data-position'].value
        const name = data['data-name'].value
        const surname = data['data-surname'].value
        const lastname = data['data-lastname'].value

        this.$fio.textContent = `${name} ${surname} ${lastname}`
        this.$img.attributes.src.value = urlImg
        this.$position.textContent = position
    }

    clickHandler(event){
        this.setActiveText(event.currentTarget)
    }
}

$activeBlock && $blocksList ? new EmployeeComment($activeBlock, $blocksList).init() : null









